import React, { useState } from 'react'

import { defineAbilityFor } from './'
import { TooltipWrapper, CancelIcon, SuccessIcon } from '../common'
import { downloadAgencyReconciliationReport } from '../../api/routes'
import { getAuthUser } from '../../helpers'
import { Report } from '../../models/report'
import { generateReport, deleteReport } from "../../api"
import { toast } from "react-toastify"

interface ReportTableProps {
    reports: Report[]
    year: number
    month: number
    onUpdateReports: (reports: Report[]) => void
}

export const ReportsTable = (props: ReportTableProps) => {
    const { reports, year, month, onUpdateReports } = props
    const [creatingAgencyId, setCreatingAgencyId] = useState<number | null>(null)

    const ability = defineAbilityFor(getAuthUser())

    const handleSingleRunReport = async (agency_id: number) => {
        setCreatingAgencyId(agency_id)
    
        try {
            await deleteReport(year, month, agency_id)
    
            const { data, status } = await generateReport(year, month, agency_id)
            if (status === 200) {
                onUpdateReports(data)
            }
        } catch (e: any) {
            toast.error(e.message || 'Something went wrong', { autoClose: false })
        }
    
        setCreatingAgencyId(null)
    }
    

    return (
        <table className="table">
            <tbody>
                <tr>
                    <th>AGENCY ID</th>
                    <th>AGENCY</th>
                    <th className="text-center">STATUS</th>
                    <th className="text-center">ACTION</th>
                    <th className="text-center">REPORTS</th>
                </tr>
                {reports.map((r: Report) => (
                    <tr key={r.id}>
                        <td>{r.agency_id}</td>
                        <td>{r.agency}</td>
                        {getStatusIndicator(r)}
                        <td className="text-center">
                            <TooltipWrapper
                                condition={!ability.can('download', 'Reports')}
                                message="You don't have the required permissions to download agency reconciliation reports."
                                element={
                                    r.completed || r.succeeded ? (
                                        <a
                                            href={`${downloadAgencyReconciliationReport}/${r.agency_id}`}
                                            className={`btn btn-primary ${!ability.can('download', 'Reports') ? 'disabled' : ''}`}
                                        >
                                            Download
                                        </a>
                                    ) : (
                                        <></>
                                    )
                                }
                            />
                        </td>
                        <td className="text-center">
                        {
                            creatingAgencyId === r.agency_id ? (
                                <LoadingButton message="Creating..." />
                            ) : !r.completed ? (
                                <div className="spinner-border spinner-border-sm text-secondary" role="status">
                                    <span className="visually-hidden">Working...</span>
                                </div>
                            ) : (
                                <button
                                    className="btn btn-primary"
                                    onClick={() => handleSingleRunReport(r.agency_id)}
                                    disabled={!ability.can('queue', 'Reports')}
                                >
                                    Re-run
                                </button>
                            )
                        }
                    </td>
                        <></>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
const getStatusIndicator = (report: Report) => {
    if (report.completed === false) {
        return (
            <td className="text-center">
                <div
                    className="spinner-border spinner-border-sm text-secondary"
                    role="status"
                >
                    <span
                        className="visually-hidden">
                        Working...
                    </span>
                </div>
            </td>
        )
    }
    if (report.succeeded === false) {
        return (
            <td className="text-center">
                <CancelIcon />
            </td>
        )
    }
    return (
        <td className="text-center">
            <SuccessIcon />
        </td>
    )
}
const LoadingButton = ({ message }: { message: string }) => (
    <button
        className="btn btn-primary"
        type="button"
        disabled
    >
        <span
            className="spinner-border spinner-border-sm me-3"
            role="status"
            aria-hidden="true"
        />
        { message }
    </button>
)